import * as React from 'react'
import cn from 'classnames'
import wordmark from 'app/packs/images/careerminds/logo-full-black.png'

export type CareermindsLogoProps = {
  className?: string
  /** `mark` renders just the initial, for a collapsed nav. */
  variant?: 'full' | 'mark'
  /** For navy surfaces, where the ink-on-white wordmark would disappear. */
  inverse?: boolean
}

/**
 * The Careerminds wordmark.
 *
 * `full` is the supplied logotype. There is no asset for the compact `mark`, so
 * that one stays live text in TT Talent — see `.cm-wordmark-mark` in
 * stylesheets/base/_careerminds-brand.scss. The wordmark is a single ink, so
 * `inverse` is a CSS filter rather than a second file.
 */
export const CareermindsLogo: React.VFC<CareermindsLogoProps> = ({
  className,
  variant = 'full',
  inverse = false,
}) => {
  if (variant === 'mark') {
    return (
      <span
        className={cn(
          'cm-wordmark-mark',
          inverse && 'cm-wordmark-inverse',
          className,
        )}
        aria-label="Careerminds"
      >
        c
      </span>
    )
  }

  return (
    <img
      src={wordmark}
      alt="Careerminds"
      className={cn('cm-logo', inverse && 'cm-logo--inverse', className)}
    />
  )
}
